import React from 'react';
import { maskDate } from '../../masks';
import { ACCOUNT_STATUSES } from '../../const.js';

const titleMap = {
  [ACCOUNT_STATUSES.ACTIVE]: 'Active',
  [ACCOUNT_STATUSES.DEACTIVATED]: 'Deactivated',
  [ACCOUNT_STATUSES.INACTIVE]: 'Inactive',
}
const AccountStatus = props => {
  const {
    className = 'p--dark-taupe',
    accountType = 'Client',
    showAccountType = true,
    accountStatus = ACCOUNT_STATUSES.ACTIVE,
    date = Date()
  } = props;
  const classes = ['account-status', 'p', className];

  let desc = ''
  if (accountStatus === ACCOUNT_STATUSES.ACTIVE) {
    desc = '| '  + activeSwitch(accountType) + maskDate(date)
  } else if (accountStatus === ACCOUNT_STATUSES.DEACTIVATED) {
    desc = `| Deactivation Date ${maskDate(date)}`
  }

  return (
    <p className={classes.join(' ')}>
      {titleMap[accountStatus]} {showAccountType ? accountType : ''}{' '}
      {desc}
    </p>
  );
};
export default AccountStatus;

const activeSwitch = type =>
  ({
    Client: 'Member Since ',
    Chef: 'Start Date: '
  }[type] || 'Since: ');



// WEBPACK FOOTER //
// ./src/components/shared/AccountStatus.js